import React from "react";
import PropTypes from "prop-types";
import DefaultLogo from "../../../../../../Assets/Images/Defaults/minerva-logo.svg";

const ClientLogoComponent = ({ clientName, compact = false }) => {
  const getClientLogo = (name) => {
    name = name === "localhost" ? "minerva-logo" : name;
    return `https://stminervaclouddev.blob.core.windows.net/images-store/${name}.png`;
  };

  const addDefaultSrc = (ev) => {
    ev.target.src = DefaultLogo;
  };

  const LOGO_HEIGHT = "40px";
  const baseLogoStyle = {
    height: LOGO_HEIGHT,
    minHeight: LOGO_HEIGHT,
    maxHeight: LOGO_HEIGHT,
    width: "auto",
    display: "block",
    margin: "4px auto",
    objectFit: "contain",
    transition: "all 220ms cubic-bezier(0.4, 0, 0.2, 1)",
  };

  const compactStyle = { ...baseLogoStyle, maxWidth: "44px" };

  const fullStyle = { ...baseLogoStyle, maxWidth: "220px" };

  return (
    <img
      style={compact ? compactStyle : fullStyle}
      alt={`${clientName} logo`}
      onError={addDefaultSrc}
      src={getClientLogo(clientName)}
    />
  );
};

ClientLogoComponent.propTypes = {
  clientName: PropTypes.string,
  compact: PropTypes.bool,
};

export default React.memo(ClientLogoComponent);
